// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 144) return "static/chunks/144-dc69df517d702736.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 432 ? "ef956ed8" : chunkId) + "." + {"432":"2a4c4ee1a100d827","841":"df30692b0cb7972d"}[chunkId] + ".js";
};